export default "__VITE_ASSET__C1To0$JO__"